import m from 'mithril'

export default m.trust(`
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 5" fill="none" style="width: var(--icon-width, 8px); height: var(--icon-height, 5px);">
		<path fill="var(--icon-color, currentColor)" d="M7.35352 0.853516L4 4.20703L0.646484 0.853516L1.35352 0.146484L4 2.79297L6.64648 0.146484L7.35352 0.853516Z"/>
	</svg>
`)
